module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Medium.accae5df.ttf";